import { Component } from "react";
import { connect } from "react-redux";

import PropTypes from "prop-types";

import { api } from "containers/Request";

import { DEFAULT_APP_PROPS } from "../_shared/constants";

const mapDispatchToProps = (dispatch) => ({
  createCloudAppCall: (body) =>
    dispatch(
      api.createApplication.action({
        options: {
          body,
        },
      })
    ),
  updateCloudAppCall: (app_id, body) =>
    dispatch(
      api.updateApplication.action({
        params: {
          app_id,
        },
        options: {
          body,
        },
      })
    ),
  setSubmissionStartedCall: (revision_id, id, body) =>
    dispatch(
      api.setSubmissionStartedStatus.action({
        params: {
          id,
          revision_id,
        },
        options: {
          body,
        },
      })
    ),
});

export const withSnapEditData = (WrappedComponent) => {
  class WithConnect extends Component {
    constructor(props) {
      super(props);
    }
    static propTypes = {
      // from @connect
      createCloudAppCall: PropTypes.func.isRequired,
      setSubmissionStartedCall: PropTypes.func.isRequired,
      updateCloudAppCall: PropTypes.func.isRequired,
      // from passed component
      storeAppId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    };
    createCloudApp = async (statusUrl) => {
      const { createCloudAppCall, name } = this.props;
      const body = JSON.stringify({
        data: {
          type: "ApplicationModel",
          attributes: {
            name,
            notify_version_status_url: statusUrl,
            ...DEFAULT_APP_PROPS,
          },
        },
      });
      const { result, error } = await createCloudAppCall(body);

      if (error) {
        throw new Error(error.message);
      }
      return result.results;
    };

    updateCloudApp = async (statusUrl) => {
      const { updateCloudAppCall, storeAppId, name } = this.props;
      // TVSNAP-3296 This is just a temporary solution, because backend is not ready yet
      // api.updateApplication should use PATCH (currently not supported by cloud)
      // only changed fields like notify_version_status_url should be included in request payload (id is mandatory)
      const body = JSON.stringify({
        data: {
          id: storeAppId,
          type: "ApplicationModel",
          attributes: {
            name,
            notify_version_status_url: statusUrl,
            ...DEFAULT_APP_PROPS,
          },
        },
      });
      const { result, error } = await updateCloudAppCall(storeAppId, body);
      if (error) {
        throw new Error(error.message);
      }
      return result.results;
    };

    setSubmittedStatus = async (revision_id, appId, cloudAppId) => {
      const { setSubmissionStartedCall } = this.props;

      const statusBody = JSON.stringify({
        app_id: cloudAppId,
        status: "SUBMISSION_STARTED",
      });
      const { error } = await setSubmissionStartedCall(
        revision_id,
        appId,
        statusBody
      );
      if (error) {
        throw new Error(error.message);
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          setSubmittedStatus={this.setSubmittedStatus}
          createCloudApp={this.createCloudApp}
          updateCloudApp={this.updateCloudApp}
        />
      );
    }
  }
  return connect(null, mapDispatchToProps)(WithConnect);
};
